import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, computed } from 'vue';
  import { onClickOutside, useElementBounding, useWindowSize } from '@vueuse/core';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppPopHover',
  setup(__props, { expose: __expose }) {
  __expose();

  const top = ref('bottom-6');
  const bottom = ref('top-6');

  const positionX = ref('right-0');
  const window = useWindowSize();
  const showPopHover = ref(false);
  const popHover = ref();
  const popWrapper = ref();
  const blockMenuBounding = useElementBounding(popHover);
  const buttonMenuBounding = useElementBounding(popWrapper);

  const position = computed(() => {
    return buttonMenuBounding.bottom.value - blockMenuBounding.height.value > 84 ? top.value : bottom.value;
  });

  onClickOutside(popHover, () => (showPopHover.value = false), { ignore: [popWrapper] });

const __returned__ = { top, bottom, positionX, window, showPopHover, popHover, popWrapper, blockMenuBounding, buttonMenuBounding, position, ref, toRefs, computed, get onClickOutside() { return onClickOutside }, get useElementBounding() { return useElementBounding }, get useWindowSize() { return useWindowSize } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})